import { AsProp, ButtonTertiary } from '@spotify-internal/encore-web';
import { ComponentProps } from 'react';

import { LinkList, MastheadLink } from 'types/navigation';

export type PopoverLink = Omit<ComponentProps<typeof ButtonTertiary>, 'children'> & {
  linkText: string;
  level: number;
  iconLeading?: AsProp;
};

export const isMastheadLinkList = (value: LinkList | MastheadLink): value is LinkList => 'entries' in value;
